// Helpers for reading "now" on the clinic's clock rather than the browser's.
//
// The backend measures every reporting boundary in the clinic's configured timezone, so the
// frontend has to agree about which month is the current one. Using the device clock would
// disagree for anyone working from a different zone than the clinic.

/**
 * Returns the calendar month ("YYYY-MM") that it currently is in the given IANA timezone.
 *
 * `en-CA` formats as YYYY-MM-DD, so slicing the first 7 characters is safe.
 */
export const currentMonthIn = (timeZone: string): string => {
  const formatted = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());

  return formatted.slice(0, 7);
};

/** Returns the browser's own current month, for use before the clinic's zone is known. */
export const currentMonthLocal = (): string => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * Returns `count` months ending at `anchor` ("YYYY-MM"), most recent first.
 *
 * Built from the string rather than a Date so it never drifts across a timezone boundary.
 */
export const recentMonths = (anchor: string, count: number): string[] => {
  const [year, month] = anchor.split('-').map(Number);
  const months: string[] = [];

  for (let i = 0; i < count; i++) {
    // Date handles the year rollover when month - i goes below 1.
    const d = new Date(year, month - 1 - i, 1);
    months.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }

  return months;
};
